import { render, staticRenderFns } from "./report-dvi.vue?vue&type=template&id=b2c3e7bc&scoped=true&"
import script from "./report-dvi.vue?vue&type=script&lang=ts&"
export * from "./report-dvi.vue?vue&type=script&lang=ts&"
import style0 from "./report-dvi.vue?vue&type=style&index=0&id=b2c3e7bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c3e7bc",
  null
  
)

export default component.exports